import React, { useState } from 'react';
import { Box, Typography, Button, InputBase, IconButton } from '@mui/material';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';

import ProjectsCard from './ProjectsCard';
import ProjectsCardTable from './ProjectsCardTable';
import BatchActions from './BatchActions';
import SingleDatePicker from '../../../components/Date-range-picker/SingleDatePicker';
import CreateNewProject from '../../../components/Projects/CreateNewProject';
import ImportProject from '../../../components/Projects/ImportProject';
import ProjectViewToggle from './ProjectViewToggle';

import GroupedSelect from '../../../components/DemoTabs/GroupedSelect';
import SingalUserImageSelect from '../../../components/DemoTabs/SingalUserImageSelect';
import DateRangePicker from '../../../components/Date-range-picker/DateRangePicker';



const projects = [
    {
        letter: 'P',
        bgColor: '#C70088',
        title: 'Pixel Flow',
        status: 'Active',
        time: 'Fri, Jan 10, 2025',
        statusColor: '#179046',
        statusBg: '#1790453D',
        description: 'In this position, you will work closely with cross-functional peers, including Product Managers, Data Analysts',
        name: 'SkyGrid',
        desk: 'Worked Desk 1',
        initials: 'SG',
        color: '#6A1B9A',
    },
    {
        letter: 'I',
        bgColor: '#D36A08',
        title: 'Interface Hub',
        status: 'Inactive',
        time: 'Fri, Feb 10, 2025',
        statusColor: '#FF4D12',
        statusBg: '#FD57573D',
        description: 'With design ingrained at all levels of our organization, including senior leadership, your impact will be valued and recognized.',
        name: 'Project Quantum',
        desk: 'Worked Desk 1',
        initials: 'PQ',
        color: '#0067C7',
    },
    {
        letter: 'A',
        bgColor: '#1A1F36',
        title: 'Analytics Suite',
        status: 'Active',
        time: 'Fri, Mar 10, 2025',
        statusColor: '#179046',
        statusBg: '#1790453D',
        description: 'As an integral part of our analytics team, you will focus on driving insights through data visualization and storytelling to impact key business decisions.',
        name: 'Creative Boost',
        desk: 'Worked Desk 2',
        initials: 'CB',
        color: '#C70088',
    },
    {
        letter: 'R',
        bgColor: '#179045',
        title: 'Research Lab',
        status: 'Active',
        time: 'Fri, Apr 10, 2025',
        statusColor: '#179046',
        statusBg: '#1790453D',
        description: 'Join our research lab where helping to innovate and develop cutting-edge products will be your primary focus, collaborating with top researchers.',
        name: 'Creative Boost',
        desk: 'Worked Desk 2',
        initials: 'CB',
        color: '#FF8328',
    },

    {
        letter: 'C',
        bgColor: '#FF4D12',
        title: 'Creative Studio',
        status: 'Active',
        time: 'Fri, May 10, 2025',
        statusColor: '#179046',
        statusBg: '#1790453D',
        description: 'Be part of our Creative Studio to develop innovative marketing campaigns, working with talented designers and strategists to make a lasting impression.',
        name: 'Creative Boost',
        desk: 'Worked Desk 2',
        initials: 'CB',
        color: '#4CAF50',
    },
    {
        letter: 'T',
        bgColor: '#9C2CF3',
        title: 'Tech Innovations',
        status: 'Active',
        time: 'Fri, Jun 10, 2025',
        statusColor: '#179046',
        statusBg: '#1790453D',
        description: 'Join our Tech Innovations team to lead groundbreaking technology projects that redefine user experience and engagement.',
        name: 'Creative Boost',
        desk: 'Worked Desk 2',
        initials: 'CB',
        color: '#1849D6',
    },
    {
        letter: 'D',
        bgColor: '#FFD521',
        title: 'Development Hub',
        status: 'Active',
        time: 'Fri, jul 10, 2025',
        statusColor: '#179046',
        statusBg: '#1790453D',
        description: 'Collaborate with passionate developers in our Development Hub to build scalable solutions and contribute to open-source projects.',
        name: 'Design Triumph',
        desk: 'Worked Desk 3',
        initials: 'DT',
        color: '#5932EA',
    },
    {
        letter: 'N',
        bgColor: '#87E64B',
        title: 'Next Gen',
        status: 'Inactive',
        time: 'Fri, Aug 10, 2025',
        statusColor: '#FF4D12',
        statusBg: '#FD57573D',
        description: 'With design ingrained at all levels of our organization, including senior leadership, your impact will be valued and recognized. Join a well-established design organization.',
        name: 'User Experience',
        desk: 'Worked Desk 4',
        initials: 'UX',
        color: '#0067C7',
    },
];

const AllProjects = () => {

    const [selectedProjects, setSelectedProjects] = useState([]);
    const projectsSnd = ['John Doe John Doe John Doe', 'Alice Johnson', 'Rahul Sharma', 'Deepa Nair'];

    const userList = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Michael Johnson', image: '' },
    ];

    const [selectedUser, setSelectedUser] = useState('');





    const [viewMode, setViewMode] = useState('card'); // or 'table'
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);       // ✅ Define it
    const handleClose = () => setOpen(false);     // Optional close handler
    const [openImportProject, setOpenImportProject] = useState(false);

    const [activeTab, setActiveTab] = useState('all');

    return (
        <div>
         
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
                <Typography className="fw-semibold mb-0" sx={{ fontSize: '24px', color: '#1A1F36', fontFamily: 'Manrope' }}>Project</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 3 }}>

                    <CustomTabPanel value={activeTab} index="all">
                        <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 3 }}>
                            <Button onClick={() => setOpenImportProject(true)} sx={{ fontFamily: 'Manrope', background: '#fff', borderRadius: '100px', color: '#0084FF', fontSize: '14px', textTransform: 'Uppercase', fontWeight: '500', height: '36px', border: 'none', padding: '8px 16px' }}>Import Project</Button>
                            <Button onClick={handleOpen} sx={{ fontFamily: 'Manrope', background: '#0076FE', borderRadius: '100px', color: '#FFFFFF', fontSize: '14px', textTransform: 'Uppercase', fontWeight: '500', height: '36px', border: 'none', padding: '8px 16px' }}>+ New Project</Button>
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={activeTab} index="archived">
                        <Button onClick={() => setOpenImportProject(true)} sx={{ fontFamily: 'Manrope', background: '#fff', borderRadius: '100px', color: '#0084FF', fontSize: '14px', textTransform: 'Uppercase', fontWeight: '500', height: '36px', border: 'none', padding: '8px 16px' }}>Import Project</Button>
                    </CustomTabPanel>
                    <CreateNewProject open={open} onClose={handleClose} />
                    <ImportProject open={openImportProject} onClose={() => setOpenImportProject(false)} />
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignContent="center">
                {/* Tabs */}
                <Box display="flex" gap={1} mb={0}>
                    <Button onClick={() => setActiveTab('all')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', textTransform: 'none', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'all' ? '#0076FE' : '#fff', color: activeTab === 'all' ? '#fff' : '#64748B', border: activeTab === 'all' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600, fontSize: '14px', padding: '8px 16px', boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        All Projects (12)</Button>
                    <Button onClick={() => setActiveTab('archived')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', textTransform: 'none', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'archived' ? '#0076FE' : '#fff',
                        color: activeTab === 'archived' ? '#fff' : '#64748B', border: activeTab === 'archived' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600, fontSize: '14px', padding: '8px 16px',
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>ARCHIVED (0)
                    </Button>
                </Box>
                {/* Tab Panel Content */}
                <Box>
                    <BatchActions />
                </Box>
            </Box>
            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="all">
                    <Box sx={{ width: '100%', '& MuiBox-root': { padding: '0' } }}>
                        <Box className="d-flex justify-content-between align-items-center flex-wrap">
                            <Box className="d-flex gap-10 align-items-center" sx={{marginBottom: '10px'}}>
                                <Paper component="form" sx={{ display: 'flex', alignItems: 'center', width: {xl: '240px' , lg: '190px'}, height: '38px', borderRadius: '100px', boxShadow: 'unset', border: '1px solid #E5E8EB' }}>
                                    <IconButton type="button" aria-label="search"><SearchIcon sx={{ fontSize: '20px', color: '#64748B' }} /></IconButton>
                                    <InputBase sx={{ ml: 0, flex: 1, fontSize: '14px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope' }} placeholder="Search Projects" inputProps={{ 'aria-label': 'Search Projects' }} />
                                </Paper>
                                {/* <SingalUserImageSelect
                                    label="Select User"
                                    options={userList}
                                    selectedValue={selectedUser}
                                    onChange={setSelectedUser}
                                />

                                <GroupedSelect
                                    label="Select Project"
                                    options={projectsSnd}
                                    selectedValues={selectedProjects}
                                    onChange={setSelectedProjects}
                                /> */}
                            </Box>
                            <Box className="d-flex gap-10 align-items-center" sx={{marginBottom: '10px'}}>
                                {/* <SingleDatePicker /> */}
                                <DateRangePicker/>
                                <ProjectViewToggle viewMode={viewMode} onChange={setViewMode} />
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ margin: '18px auto 32px', '& MuiBox-root': { padding: '0' } }}>
                        <div>
                            {viewMode === 'card' ? (
                                <ProjectsCard projects={projects} />
                            ) : (
                                <ProjectsCardTable projects={projects} />
                            )}
                        </div>
                        {/* <ProjectsCard /> */}
                    </Box>
                </CustomTabPanel>


                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="archived">
                    <Box sx={{ width: '100%' }}>
                        <Box className="d-flex justify-content-between align-items-center">
                            <Box className="d-flex gap-10 align-items-center">
                                <Paper component="form" sx={{ display: 'flex', alignItems: 'center', width: '300px', height: '38px', borderRadius: '100px', boxShadow: 'unset', border: '1px solid #E5E8EB' }}>
                                    <IconButton type="button" aria-label="search"><SearchIcon sx={{ fontSize: '20px' }} /></IconButton>
                                    <InputBase sx={{ ml: 0, flex: 1, fontSize: '14px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope', }} placeholder="Search Projects" inputProps={{ 'aria-label': 'Search Projects' }} />
                                </Paper>
                            </Box>
                            <Box className="d-flex gap-10 align-items-center">
                                <ProjectViewToggle viewMode={viewMode} onChange={setViewMode} />
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ margin: '18px auto 32px' }}>
                        <div>
                            {viewMode === 'card' ? (
                                <ProjectsCard projects={projects} />
                            ) : (
                                <ProjectsCardTable projects={projects} />
                            )}
                        </div>
                        {/* <ProjectsCard /> */}
                    </Box>
                </CustomTabPanel>
            </Box>
        </div>
    )
};
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box p={2}>{children}</Box>;
};

export default AllProjects
